import React, {Component} from 'react';
import {observer, inject} from 'mobx-react';
import Chat from 'react-icons/lib/go/comment';
import Button from '@material-ui/core/Button';
import AvatarIcon from "../AvatarIcon";
import './styles.scss';

const avatarIconStyle = {
    width: '34px',
    height: '34px',
    minWidth: '34px',
    minHeight: '34px',
    border: '2px solid white'
};

@inject('chatStore', 'mainStore', 'manageStore')
@observer
class ChatButton extends Component {
    handleClick = () => {
        const {teacher, chatStore, mainStore} = this.props;
        chatStore.setActiveChat(teacher.id);
        mainStore.openMainAppDrawer();
        if (this.props.onClick) {
            this.props.onClick();
        }
    };

    render() {
        const {teacher} = this.props;
        return (
            <Button onClick={this.handleClick}>
                <div className="chat-button-wrapper">
                    <div className="chat-button-avatar-name">
                        <AvatarIcon
                            iconStyle={avatarIconStyle}
                            defaultIconStyle={avatarIconStyle}
                            style={{background: 'none'}}
                            icon={teacher.avatar}
                            useDefault={true}
                            fullName={teacher.name}
                        />
                        <div className="chat-button-name">
                            {teacher.name}
                        </div>
                    </div>
                    <div className="chat-button-icon">
                        <Chat/>
                    </div>
                </div>
            </Button>
        );
    }
}

export default ChatButton;
